export const STORAGE_KEY = {
    USER: 'userInfo',
    WS_CLIENT_ID: '_HQB_WS_CLIENT_ID',
    AI_ASSISTANT_WS_CLIENT_ID: '_HQB_AI_ASSISTANT_WS_CLIENT_ID',
    AI_ASSISTANT_CONVERSATION_ID: '_HQB_AI_ASSISTANT_CONVERSATION_ID',
}
